module.exports = __webpack_public_path__ + "public/images/slider/speaker-1.e911ccd1f47ab2b3e421a2eaa3d8e4d7.jpeg";